import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getOrderAge } from "./fulfillment-group-csv-utils";

export const OrderAgeCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Order age", cell: (row) => getOrderAge(row) };
